/**
 * The provider's error on an OAuth return that carries no credential, or null.
 * X puts it in the query (`?error=access_denied`); Apple and Google use the
 * fragment (`#error=user_cancelled_authorize`). A return that also carries a
 * code or id_token is a success and yields null.
 */
export function readOauthReturnError(search: string, hash: string): string | null {
  const query = new URLSearchParams(search);
  const fragment = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const error = query.get('error') ?? fragment.get('error');
  if (error === null) return null;
  const hasCredential = query.has('code') || fragment.has('code') || fragment.has('id_token');
  return hasCredential ? null : error;
}
